var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (t) {
buf.push("<ul><li class=\"preset\">" + (jade.escape(null == (jade_interp = t('step preset')) ? "" : jade_interp)) + "</li><li class=\"import\">" + (jade.escape(null == (jade_interp = t('step import')) ? "" : jade_interp)) + "</li><li class=\"email\">" + (jade.escape(null == (jade_interp = t('step email settings')) ? "" : jade_interp)) + "</li></ul>");}.call(this,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/view_register_feedback.jade
 ** module id = 70
 ** module chunks = 0
 **/